import { useLoginMutation } from '../../../../react-query/authentication/mutation/use-login-mutation'
import { useLogin2faMutation } from '../../../../react-query/authentication/mutation/use-login-2fa-mutation'
import { useLoginVerifyEmailMutation } from '../../../../react-query/authentication/mutation/use-login-verify-email-mutation'

export const useLoginMutations = () => {
  const login = useLoginMutation()
  const login2fa = useLogin2faMutation()
  const verifyEmail = useLoginVerifyEmailMutation()

  const resetLoginMutations = () => {
    login.reset()
    login2fa.reset()
  }

  return {
    handleLoginHook: login.mutateAsync,
    handleLogin2faHook: login2fa.mutateAsync,
    handleVerifyEmail: verifyEmail.mutateAsync,
    isLoading: login.isPending || login2fa.isPending,
    loginError: login.error,
    login2faError: login2fa.error,
    emailWrong: verifyEmail.error,
    emailVerified: verifyEmail.data,
    emailVerifying: verifyEmail.isPending,
    resetLoginMutations
  }
}
